const WareHouse = {

    // FIELDS
    "business_area": "Sakop ng Negosyo",
    "name": "Pangalan",
    "short_name": "Maikling Pangalan",
    "address": "Adres",
    "description": "Paglalarawan",
    "contact_no": "Numero ng Pakikipag-ugnayan",
    "email": "Email",
    "contact_person_name": "Pangalan ng Nakatalagang Tao",
    "contact_person_no": "Numero ng Nakatalagang Tao",
    "type": "Uri",
    "search": "Maghanap",

    // PAGE HEADER
    "ware_house": "Bodega",

    // ERROR
    "error_business_area": "Piliin ang Sakop ng Negosyo",
    "error_name": "Ilagay ang Pangalan",
    "error_short_name": "Ilagay ang Maikling Pangalan",
    "error_address": "Ilagay ang Adres",
    "error_description": "Ilagay ang Paglalarawan",
    "error_contact_no": "Ilagay ang Numero ng Pakikipag-ugnayan",
    "error_email": "Ilagay ang Email",
    "error_contact_person_name": "Ilagay ang Pangalan ng Nakatalagang Tao",
    "error_contact_person_no": "Ilagay ang Numero ng Nakatalagang Tao",
    "error_type": "Piliin ang Uri",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_short_name": "MAIKLING PANGALAN",
    "table_business_area": "SAKOP NG NEGOSYO",
    "table_address": "ADRES",
}

export default WareHouse;